import React from "react";
import "./SafeArea.css";
import PropTypes from "prop-types";

/**
 * SafeArea: Un composant qui ajoute des marges internes (padding)
 * autour de son contenu pour éviter que celui-ci ne soit collé aux bords de l'écran.
 *
 * @param {React.ReactNode} children - Le contenu à afficher à l'intérieur de la zone sécurisée.
 * @param {object} style - Styles additionnels personnalisés.
 * @param {object} props - Propriétés additionnelles pour le conteneur.
 */
const SafeArea = ({ children, className = "", style = {}, ...props }) => {
  return (
    <div
      className={`SafeArea ${className}`}
      style={{
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

SafeArea.propTypes = {
  /** Contenu à afficher dans la zone sécurisée */
  children: PropTypes.node.isRequired,
  /** Styles additionnels à appliquer */
  style: PropTypes.object,
};

export default SafeArea;
